import React from 'react';
import ModulePlaceholder from '../common/ModulePlaceholder';

export default function Services() {
  return (
    <ModulePlaceholder
      title="Services"
      icon="🛠️"
      description="Manage service items and service-related workflows for your business."
      related={[
        { label: 'Products & Services', path: '/products' },
        { label: 'Estimates', path: '/estimates' },
        { label: 'Invoices', path: '/invoices' },
      ]}
    />
  );
}
